module.exports = __webpack_public_path__ + "static/media/ExpertMain.5b6a37f3.docx";